const BUILDER_PREVIEW_HOSTNAME = "skywire-co-uk-preview.pages.dev";

export function isBuilderPreviewHost(hostname: string) {
    return hostname === BUILDER_PREVIEW_HOSTNAME;
}
